module.exports = "../images/locket.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/locket.png
// module id = 912
// module chunks = 1